import React, {  Component } from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';

import _ from 'lodash';

/* Actions */
import { getOrderDetails, saveOrderDetails } from '../../../redux/actions';

class PreviousViewReturnRequests extends Component {

	constructor(props) {
		super(props);
		this.state = {
			errorMessage: '',
		}
	}

	componentDidMount() {
		const self = this,
			{ previousReturnRequestDetails } = self.props.state.order;
		if(!previousReturnRequestDetails) {
			browserHistory.push('/requestreturn');
		} else {
			const orderNumbers = [];
			previousReturnRequestDetails.returnLines.forEach(itm => {
				orderNumbers.push(itm.returnNumber);
			});
				self.props.getOrderDetailsInParallelBatches(orderNumbers);
		}
	}
	
	handleFetchOrderDetails(orderNumber, wheretoRedirect, event) {
		event.preventDefault();
		var self = this;
		self.props.getOrderDetails('orderNumber='+orderNumber+'&requestType=getOrderDetails&accountNumber='+self.props.getSelectedAccountNumber(), (response) => {
			if(!response.status) {
				self.setState({
					errorMessage: response.responseMessage
				})
			} else {
				browserHistory.push('/' + wheretoRedirect);
			}
		});
	}

    render() {
		const self = this;
		const { previousReturnRequestDetails } = this.props.state.order;
        return (
			<div>
		         <div className="push m-3">
		          	<h1 className="pageTitle">Previous Returns and Credit Requests</h1>
		        </div>
			  	<p className="red bold">{this.state.errorMessage}</p>
				  <p className="bold m-3">Original Order: { previousReturnRequestDetails.orderNum }</p>
				{previousReturnRequestDetails && previousReturnRequestDetails.returnLines &&
			         <div className="push m-3">
			          	<div className="captionAboveTable">
				            <div className="columns twoColumns">
				              	<div className="column">
				                	<div className="bold big">{previousReturnRequestDetails.returnLines.length} Requests</div>
				              	</div>
				            </div>
			          	</div>
			          	<table className="dataTable viewReturnsTable d-none d-sm-block">
							<thead>
								<tr>
									<th>Request #</th>
									<th>Return Line #</th>
									<th>Status</th>
									<th>QTY</th>
									<th>Amount</th>
									<th>Reason</th>
									<th>Credit Invoice</th>
								</tr>
							</thead>
			            	<tbody>
								{previousReturnRequestDetails.returnLines.map((item, index) => {
									let invoiceNumber = '';
									let status = '';
									if(self.props.allBatchesCompleted) {
										const data = self.props.orderDetailsOfOrderNumbers.find(itm => itm.orderNumber === item.returnNumber);
										if(data && data.items) {
											const dataLineNo = data.items.find(itm => item.lineNumber && itm.lineNo === item.lineNumber.toString())
											status = dataLineNo.lineStatus;
											invoiceNumber = dataLineNo.invoiceNumber;
										}
									}
									return <tr key={index}>
										<td>
											<a className="bold" href="" onClick={this.handleFetchOrderDetails.bind(this, item.returnNumber, 'viewrequestsorderdetails')}>{item.returnNumber}</a>
										</td>
										<td>{item.lineNumber}</td>
										<td>{status}</td>
										<td>{item.authorizedQty}</td>
										<td>{item.creditPrice}</td>
										<td>{item.returnReason}</td>
										<td>{invoiceNumber}</td>
									</tr>
								})}
			            	</tbody>
			          	</table>
						  {previousReturnRequestDetails.returnLines.map((item, index) => {
									let invoiceNumber = '';
									let status = '';
									if(self.props.allBatchesCompleted) {
										const data = self.props.orderDetailsOfOrderNumbers.find(itm => itm.orderNumber === item.returnNumber);
										if(data && data.items) {
											const dataLineNo = data.items.find(itm => item.lineNumber && itm.lineNo === item.lineNumber.toString())
											status = dataLineNo.lineStatus;
											invoiceNumber = dataLineNo.invoiceNumber;
										}
									}
									return  <div className="accordion accordion-borderless d-block d-sm-none" id={`accordionPreviousCredits${index}`}  key={index}>
									<div>
										<h2 className="accordion-header" id={`flush-headingOnePreviousCredit${index}`}>
										<button className="accordion-button mobileAccButton" type="button" data-bs-toggle="collapse" data-bs-target={`#flush-collapseOnePreviousCredit${index}`} aria-expanded="true" aria-controls={`flush-collapseOnePreviousCredit${index}`}>
											{`RETURN CSO NUMBER`} {<a className="bold"  style={{paddingLeft:"1rem"}} href="" onClick={this.handleFetchOrderDetails.bind(this, item.returnNumber, 'viewrequestsorderdetails')}>{item.returnNumber}</a>}
											</button>
											</h2>
											<div id={`flush-collapseOnePreviousCredit${index}`} className={`accordion-collapse collapse show`} aria-labelledby={`flush-headingOnePreviousCredit${index}`} data-bs-parent={`#accordionPreviousCredits${index}`}>
													<table className='orderTable'>
														<tbody>
															<tr className='border-bottom'>
																<td className='p-3 fw-bold'>RETURN LINE #</td>
																<td className="invoiceDate">{item.lineNumber}</td>
															</tr>
															<tr className='border-bottom'>
																<td className='p-3 fw-bold'>STATUS</td>
																<td className="product">{status}</td>
															</tr>
															<tr className='border-bottom'>
																<td className='p-3 fw-bold'>AMOUNT</td>
																<td className="serial">${item.creditPrice}</td>
															</tr>
															<tr className='border-bottom'>
																<td className='p-3 fw-bold'>QTY</td>
																<td className="invoiceNumber">{item.authorizedQty}</td>
															</tr>
															<tr className='border-bottom'>
																<td className='p-3 fw-bold'>CREDIT INVOICE</td>
																<td className="invoiceNumber">{invoiceNumber}</td>
															</tr>
															<tr>
																<td className='p-3 fw-bold'>REASON</td>
																<td className="invoiceNumber">{item.returnReason}</td>
															</tr>
														</tbody>
													</table>
									</div>
								</div>
							</div>
						  })}
			        </div>
				}
	      	</div>
        );
    }
}

const mapStateToProps = (state) => {
	return {state};
};

const mapDispatchToProps = (dispatch) => ({
	getOrderDetails: (queryStringParams, callback) => dispatch(getOrderDetails(queryStringParams, callback)),
	saveOrderDetails: (data) => dispatch(saveOrderDetails(data)),
});

PreviousViewReturnRequests = connect(mapStateToProps, mapDispatchToProps)(PreviousViewReturnRequests);
export default PreviousViewReturnRequests;



// WEBPACK FOOTER //
// ./src/App/components/PostLogin/Order/previousReturnAndCredit.js